let single = false;

export const setSingle = (newSingle: boolean) => {
  single = newSingle;
};

export const isSingle = () => {
  return single;
};
